export default __webpack_public_path__ + "img/active-additives.fecac810.png";